/** Convert a club name to a URL-safe slug. */
export function generateSlug(name: string): string {
  return name
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9 -]+/g, '')
    .replace(/[ -]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 60);
}

/** Matches a v4 UUID string. Used to detect legacy UUID-based URLs. */
export const UUID_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * Valid slug: starts and ends with alphanumeric, only lowercase letters,
 * digits, and hyphens, total length 3–60 characters.
 */
export const SLUG_REGEX = /^[a-z0-9][a-z0-9-]{1,58}[a-z0-9]$/;
